import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';

/**
 *  This component uses css borders to display a ribbon offset to the right or left and uses uiContext to
 *  dictate which background colors will be used.
 */
function Ribbon(_ref) {
  let {
    label,
    position = 'right',
    className,
    uiContext = null,
    newClass,
    ...rest
  } = _ref;
  const context = uiContext;
  const ribbonClasses = clsx({
    ribbon: true,
    'text-bold': uiContext !== 'payment',
    [`${position}`]: true,
    [`ribbon-${context}`]: context
  }, className);
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: ribbonClasses
  }, rest), /*#__PURE__*/_jsx("div", {
    className: `ribbon-content-${position}`
  }, void 0, label));
}
export default Ribbon;